import { useCallback } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellString } from '../../table/cells/CellString';

export const ModelCellAttachmentsBase = ({
  getValue,
  ...props
}: TableInheritedProps) => {
  const syntheticGetValue = useCallback(
    () => (getValue!()?.length ? `${getValue!()?.length} files` : undefined),
    [getValue]
  );

  return <CellString getValue={syntheticGetValue} {...props} />;
};

export const ModelCellAttachments = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellAttachments',
    ModelCellAttachmentsBase,
    props
  );
